import React, { ReactNode } from 'react';
import './Canvas.scss';

/**
 * Canvas panels must not use IonPage. Nested IonPages register with the Ionic
 * router outlet and can leave the homepage shifted under the menu when closed.
 */
export const CanvasEmbeddedPage: React.FC<{
  id?: string;
  className?: string;
  children: ReactNode;
}> = ({ id, className, children }) => (
  <div
    id={id}
    className={
      className ? `canvas-embedded-page ${className}` : 'canvas-embedded-page'
    }
  >
    {children}
  </div>
);

export default CanvasEmbeddedPage;
